import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import ComponentModal, { ModalSize } from "./ComponentModal";
import PropTypes from "prop-types";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "CHANGE_OWNER_MODAL_WIZARD";
const ModalId = "ChangeOwnerModalWizardId"

const ChangeOwnerModalWizard = (props) => {
    const intl = useIntl();

    const [modal, setModal] = useState(null);
    const [disableFirstButton, setDisableFirstButton] = useState(props.disableFirstButton);
    const [actionParameters, setActionParameters] = useState(null);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
    }, []);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect getComponent");
        if (props.getComponent) {
            setDisableFirstButton(props.disableFirstButton);
            setActionParameters(null);
        }
    }, [props.getComponent]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect getComponent, disableFirstButton");
        if (props.getComponent) {
            setModal(
                <ComponentModal
                    id={ModalId}
                    title={props.title}
                    icon={props.icon}
                    showModalOnInit={true}
                    showFirstButton={true}
                    firstButtonLabel={intl.messages.applicationEditionOwnerChangeUpdateButton}
                    disableFirstButton={disableFirstButton}
                    onClick={handleAction}
                    disableDismiss={true}
                    size={ModalSize.Medium}
                >
                    {props.getComponent(handleEnableAction, actionParameters, disableFirstButton)}
                </ComponentModal>
            )
        }
    }, [props.getComponent, disableFirstButton]);

    const handleEnableAction = (actionParams) => {
        LogService.debug(LOG_TAG, "handleEnableAction");
        setDisableFirstButton(false);
        setActionParameters(actionParams);
    }

    const handleAction = (event) => {
        LogService.debug(LOG_TAG, "handleAction");
        if (props.action) {
            props.action(actionParameters)
                .then((object) => {
                    handleOnSuccess(object?.title);
                })
                .catch((object) => {
                    handleOnFailed(object?.title, object?.errorMessage);
                });
        }
    }

    const handleOnSuccess = (title) => {
        LogService.debug(LOG_TAG, "handleOnSuccess");
        setModal(
            <ComponentModal
                id={ModalId}
                title={title}
                icon={props.icon}
                showModalOnInit={true}
                showFirstButton={true}
                firstButtonLabel={intl.messages.close}
                onClick={() => setModal(null)}
                size={ModalSize.Medium}
            >
            </ComponentModal>
        );
    }

    const handleOnFailed = (title, errorMessage) => {
        LogService.debug(LOG_TAG, "handleOnFailed");
        setModal(
            <ComponentModal
                id={ModalId}
                title={title}
                icon={props.icon}
                showModalOnInit={true}
                showFirstButton={true}
                firstButtonLabel={intl.messages.close}
                onClick={() => setModal(null)}
                size={ModalSize.Medium}
                iconColor="warning"
            >
                <div className="list">
                    {errorMessage}
                </div>
            </ComponentModal>
        );
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div>
            {modal}
        </div>
    );
}

ChangeOwnerModalWizard.defaultProps = {
    title: "",
    icon: null,
    getComponent: null,
    action: null,
    disableFirstButton: false
}

ChangeOwnerModalWizard.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    getComponent: PropTypes.func,
    action: PropTypes.func,
    disableFirstButton: PropTypes.bool
};

export default ChangeOwnerModalWizard;